import { create } from "zustand";
import { downloadEngagementReportData, downloadEngagementReportDatav2, getEngagementReportData, getReportData } from "../api_layer/api";
import { toast } from 'react-toastify';
import moment from 'moment';
import { temporaryAssignment } from "modules/manage_weekly-schedule/api_layer/api";
import secureLocalStorage from "react-secure-storage";

export const useStoreReport = create((set) => ({
  slotData: [],
  slotTotalData: [],
  ivrData: [],
  prescriptionData: [],
  weekOneData: [],
  weekThreeData: [],
  retentionData: [],
  feedbackData: [],
  adhocData: [],
  concernCall: [],
  slotBookingMedicalData:[],
  slotLoading: false,
  slotTotalLoading: false,
  ivrLoading: false,
  prescriptionLoading: false,
  weekOneLoading: false,
  weekThreeLoading: false,
  retentionLoading: false,
  feedbackLoading: false,
  adhocLoading: false,
  concernLoading: false,
  slotBookingMedicalLoding:false,
  isLoading: false,
  error: null,
  fetchSlot: async (startDate, endDate, queryParams) => {
    try {
      set({ slotLoading: true, error: null });
      const response = await getReportData(
        startDate,
        endDate,
        "slot_booking",
        queryParams
      );
      set({ slotData: response.data, slotLoading: false });
    } catch (error) {
      set({ error: error.message, slotLoading: false });
    }
  },
  fetchTotalSlot: async (startDate, endDate, queryParams) => {
    try {
      set({ slotTotalLoading: true, error: null });
      const response = await getReportData(
        startDate,
        endDate,
        "slot_booking_total",
        queryParams
      );
      set({ slotTotalData: response.data, slotTotalLoading: false });
    } catch (error) {
      set({ error: error.message, slotTotalLoading: false });
    }
  },
  fetchIvr: async (startDate, endDate, queryParams) => {
    try {
      set({ ivrLoading: true, error: null });
      const response = await getReportData(
        startDate,
        endDate,
        "ivr_booking",
        queryParams
      );
      set({ ivrData: response.data, ivrLoading: false });
    } catch (error) {
      set({ error: error.message, ivrLoading: false });
    }
  },
  fetchPrescription: async (startDate, endDate, queryParams) => {
    try {
      set({ prescriptionLoading: true, error: null });
      const response = await getReportData(
        startDate,
        endDate,
        "prescription_call",
        queryParams
      );
      set({ prescriptionData: response.data, prescriptionLoading: false });
    } catch (error) {
      set({ error: error.message, prescriptionLoading: false });
    }
  },
  fetchWeekOne: async (startDate, endDate, queryParams) => {
    try {
      set({ weekOneLoading: true, error: null });
      const response = await getReportData(
        startDate,
        endDate,
        "week_1",
        queryParams
      );
      set({ weekOneData: response.data, weekOneLoading: false });
    } catch (error) {
      set({ error: error.message, weekOneLoading: false });
    }
  },
  fetchWeekThree: async (startDate, endDate, queryParams) => {
    try {
      set({ weekThreeLoading: true, error: null });
      const response = await getReportData(
        startDate,
        endDate,
        "week_3",
        queryParams
      );
      set({ weekThreeData: response.data, weekThreeLoading: false });
    } catch (error) {
      set({ error: error.message, weekThreeLoading: false });
    }
  },
  fetchRetention: async (startDate, endDate, queryParams) => {
    try {
      set({ retentionLoading: true, error: null });
      const response = await getReportData(
        startDate,
        endDate,
        "retention",
        queryParams
      );
      set({ retentionData: response.data, retentionLoading: false });
    } catch (error) {
      set({ error: error.message, retentionLoading: false });
    }
  },
  fetchFeedback: async (startDate, endDate, queryParams) => {
    try {
      set({ feedbackLoading: true, error: null });
      const response = await getReportData(
        startDate,
        endDate,
        "feedback_call",
        queryParams
      );
      set({ feedbackData: response.data, feedbackLoading: false });
    } catch (error) {
      set({ error: error.message, feedbackLoading: false });
    }
  },
  fetchAdhoc: async (startDate, endDate, queryParams) => {
    try {
      set({ adhocLoading: true, error: null });
      const response = await getReportData(
        startDate,
        endDate,
        "adhoc_call",
        queryParams
      );
      set({ adhocData: response.data, adhocLoading: false });
    } catch (error) {
      set({ error: error.message, adhocLoading: false });
    }
  },
  fetchConcern: async (startDate, endDate, queryParams) => {
    try {
      set({ concernLoading: true, error: null });
      const response = await getReportData(
        startDate,
        endDate,
        "concern_call",
        queryParams
      );
      set({ concernCall: response.data, concernLoading: false });
    } catch (error) {
      set({ error: error.message, concernLoading: false });
    }
  },
  fetchSlotBookingMedical: async (startDate, endDate, queryParams) => {
    try {
      set({ slotBookingMedicalLoding: true, error: null });
      const response = await getReportData(
        startDate,
        endDate,
        "slot_booking_medical",
        queryParams
      );
      set({ slotBookingMedicalData: response.data, slotBookingMedicalLoding: false });
    } catch (error) {
      set({ error: error.message, slotBookingMedicalLoding: false });
    }
  },
}));

export const useEngagementReport = create((set) => ({
  engagementData: [],
  error: null,
  isLoading: false,
  updateLoading:false,
  fetchEngagements: async (
    startDate,
    endDate,
    type,
    queryParams,
    pageNumber,
    pageSize
  ) => {
    set({ error: null, isLoading: true });
    try {
      const response = await getEngagementReportData(
        startDate,
        endDate,
        type,
        queryParams,
        pageNumber,
        pageSize
      );
      set({ engagementData: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
  downloadReportv2: async (setBtnDisable, startDate, endDate, type, queryParams) => {
    try {
      toast.info(`Downloading please wait for 1-2 mins...`, {
        position: "top-center",
      });
      setBtnDisable(true);
      const response = await downloadEngagementReportDatav2(startDate, endDate, type, queryParams);
      setBtnDisable(false);
      if (response.status !== 200) {
        throw new Error('Failed to download file');
      }

      // Extract filename from Content-Disposition header
      const contentDisposition = response.headers.get('Content-Disposition');
      const filename = contentDisposition
        .split(';')[1]
        .trim()
        .split('=')[1]
        .replace(/^"(.*)"$/, '$1');
    

      const csvData = response.data;
      const url = window.URL.createObjectURL(new Blob([csvData])) 
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)

      link.click()
      link.remove()

      toast.success(`File Downloaded`, {
        position: "top-center",
      });
    } catch (error) {
      toast.error(`Failed to download`, {
        position: "top-center",
      });
      console.log("Error =", error);
    }
  },

  downloadReport: async (startDate, endDate, type, queryParams) => {
    try {
      await downloadEngagementReportData(startDate, endDate, type, queryParams);
      toast.success(`Email sent at ${secureLocalStorage.getItem("email")}`, {
        position: "top-center",
      });
    } catch (error) {
      toast.error(`Failed to send email at ${secureLocalStorage.getItem("email")}`, {
        position: "top-center",
      });
      console.log("Error ", error);
    }
  },
  
  updateEngRepData: async (payload, setToaster) => {
    const callFunction = payload?.map((item) => {
      return temporaryAssignment(item);
    });
    try {
      set({updateLoading:true})
      Promise.all(callFunction)
        .then((data) => {
          setToaster("Ticket Assigned", "Assigned Successfully", "success");
          set({updateLoading:false})
        })
        .catch((error) => {
          setToaster(
            "Ticket Assignment",
            "One or more Engagement Data could not be assigned, Refresh page with latest data",
            "danger"
          );
          set({updateLoading:false})
        });
    } catch (error) {
      set({ error: error.message, errorUpdate: true });
      set({updateLoading:false})
    }
  },
}));
